import React, { useState, useRef } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import './SidebarSection.scss'

interface SidebarSectionProps {
  title: string
  defaultExpanded?: boolean
  collapsible?: boolean
  actionIcon?: React.ComponentType<{ size?: number }>
  onAction?: () => void
  children: React.ReactNode
}

export const SidebarSection: React.FC<SidebarSectionProps> = ({
  title,
  defaultExpanded = true,
  collapsible = false,
  actionIcon: ActionIcon,
  onAction,
  children
}) => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)
  const hasToggledRef = useRef(false)

  const handleToggle = () => {
    if (collapsible) {
      hasToggledRef.current = true
      setIsExpanded(!isExpanded)
    }
  }

  return (
    <div className={`sidebar-section ${!isExpanded ? 'sidebar-section--collapsed' : ''}`}>
      <div
        className={`sidebar-section__header ${collapsible ? 'sidebar-section__header--collapsible' : ''}`}
        onClick={handleToggle}
      >
        <div className="sidebar-section__title-group">
          {collapsible && (
            <span className="sidebar-section__chevron">
              {isExpanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
            </span>
          )}
          <span className="sidebar-section__title">{title}</span>
        </div>

        {ActionIcon && onAction && (
          <button
            className="sidebar-section__action"
            onClick={(e) => {
              e.stopPropagation()
              onAction()
            }}
            title={t('sidebar.addItem', { title })}
          >
            <ActionIcon size={16} />
          </button>
        )}
      </div>

      {isExpanded && (
        <div className={`sidebar-section__content ${hasToggledRef.current ? 'sidebar-section__content--animate' : ''}`}>
          {children}
        </div>
      )}
    </div>
  )
}